/** AUTO-GENERATED — do not edit. Source: web/API/Constants/AppViewIds.cs */
/** Regenerate: npm run generate:app-view-ids */
export const AppViewIds = {
    Plans: 'a1000001-0001-0001-0001-000000000001',
    PlanInbox: 'a1000001-0001-0001-0001-000000000002',
    Upload: 'a1000001-0001-0001-0001-000000000003',
    Surveys: 'a1000001-0001-0001-0001-000000000004',
    ReceivedEstimates: 'a1000001-0001-0001-0001-000000000005',
    CustomerEstimates: 'a1000001-0001-0001-0001-000000000006',
    FindProcessor: 'a1000001-0001-0001-0001-000000000008',
    Customers: 'a1000001-0001-0001-0001-000000000009',
    Contacts: 'a1000001-0001-0001-0001-00000000000a',
    Instructions: 'a1000001-0001-0001-0001-00000000000c',
    AppDownload: 'a1000001-0001-0001-0001-00000000000d',
    Account: 'a1000001-0001-0001-0001-00000000000e',
    CompaniesViewer: 'a1000001-0001-0001-0001-000000000011',
    Configuration: 'a1000001-0001-0001-0001-000000000012',
    RulerCreator: 'a1000001-0001-0001-0001-000000000013',
    Licensing: 'a1000001-0001-0001-0001-000000000014',
    BotmarkInvoiceTable: 'a1000001-0001-0001-0001-000000000015',
    AppManagement: 'a1000001-0001-0001-0001-000000000016',
    PdfUpload: 'a1000001-0001-0001-0001-000000000017',
    AccountUserInfo: 'a1000001-0001-0001-0001-000000000018',
    AccountCompany: 'a1000001-0001-0001-0001-000000000019',
    AccountEmployees: 'a1000001-0001-0001-0001-00000000001a',
    AccountPriceOptions: 'a1000001-0001-0001-0001-00000000001b',
    AccountLicenses: 'a1000001-0001-0001-0001-00000000001c',
    AccountRulers: 'a1000001-0001-0001-0001-00000000001d',
    SurveysReceived: 'a1000001-0001-0001-0001-00000000001e',
    SurveysSent: 'a1000001-0001-0001-0001-00000000001f',
    PlansAdmin: 'a1000001-0001-0001-0001-000000000020',
    PlanInboxAdmin: 'a1000001-0001-0001-0001-000000000021',
};
